import { useState } from "react";
import { Text, StyleSheet } from "react-native";

// Data
import { useSelector } from "react-redux";
import { nanoid } from "@reduxjs/toolkit";
import { selectWatchlistInsights } from "../../redux/mainSlice";

// Components
import Times, { TimeOption } from "../common/Times";
import WatchedCard from "./WatchedCard/WatchedCard";

// Styles
import { Typography } from "../../styles";

const Watchlist = () => {
  const watchlistInsights = useSelector(selectWatchlistInsights);

  const [selectedTimeOption, setSelectedTimeOption] =
    useState<TimeOption>("2m");

  return (
    <>
      <Text style={Typography.sectionTitle}>Watchlist</Text>
      {watchlistInsights.length > 0 ? (
        <>
          <Times
            selected={selectedTimeOption}
            setSelected={setSelectedTimeOption}
          />

          {watchlistInsights.map((wi, index) => (
            <WatchedCard
              key={nanoid()}
              id={wi.id}
              timeOption={selectedTimeOption}
              style={{
                marginBottom: index !== watchlistInsights.length - 1 ? 20 : 0,
              }}
            />
          ))}
        </>
      ) : (
        <Text style={[Typography.paragraph, styles.watchlistPlaceholderText]}>
          Click "Add to Watchlist" on an insight to start tracking it
        </Text>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  watchlistPlaceholderText: {
    alignSelf: "center",
    textAlign: "center",
    opacity: 0.7,
    maxWidth: 200,
  },
});

export default Watchlist;
